import React from "react";

import { withRedux } from "helpers";
import PictureCatalog from "./PictureCatalog";
import Modal from "@material-ui/core/Modal";
import PictureCatalogSettings from "./PictureCatalogSettings";

class EditPictureCatalogComponent extends React.Component {
  // componentWillUnmount() {
  //   this.props.actions.updateActiveEditor(null);
  // }

  componentDidMount() {
    this.props.actions.updateActiveEditor(null);
  }

  componentWillUnmount() {
    this.props.actions.refreshActiveEditor();
  }

  toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;

    updateActiveEditor(idx);
  };

  render() {
    // console.log("#### loading sections to edit: ");
    // console.dir(component);
    const {
      deals,
      activeEditor,
      activeTemplate,
      activeApp: { id },
      actions: { updateActiveEditor },
      updateComponent,
    } = this.props;

    // console.dir(this.props);

    // console.log("active section found: " + activeEditor);

    const activeSection =
      activeTemplate.components[0].view.sections[activeEditor];

    // console.log("Pic Catalog Editor received active component via props:");
    // console.dir(activeTemplate.components[0]);
    return (
      <div>
        <PictureCatalogSettings />
        <Modal
          open={activeSection}
          disableScrollLock={false}
          disableAutoFocus={true}
          onClose={() => updateActiveEditor(null)}
          style={{
            top: "25%",
            width: "60%",
            marginLeft: "240px",
            marginRight: "auto",
          }}
        >
          <PictureCatalog
            section={activeSection}
            component={activeTemplate.components[0]}
            activeEditor={activeEditor}
            updateComponent={updateComponent}
          />
        </Modal>
      </div>
    );
  }
}

export default withRedux(EditPictureCatalogComponent);
